import { useState } from 'react';
import { Redirect, useLocalSearchParams } from 'expo-router';
import { StyleSheet } from 'react-native';

import { View, Text } from '@/components/Themed';
import { useUser } from './user-context';
import { useAuthCallback } from '@/app/auth/useAuthCallback';
import { useI18n } from '@/i18n';

export default function Callback() {
  const { code, state } = useLocalSearchParams<{ code?: string; state?: string }>();
  const { user, setUser } = useUser();
  const { t } = useI18n();
  const [error, setError] = useState<string | null>(null);
  const { loading } = useAuthCallback({ code, state, user, setUser, onError: setError });

  if (user) {
    return <Redirect href="/tournaments" />;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.message}>{loading ? t('auth.callbackLoading') : t('auth.callbackReady')}</Text>
      {error ? <Text style={styles.error}>{error}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
  },
  message: {
    color: '#e2e8f0',
  },
  error: {
    color: '#ff7b7b',
  },
});
